/**
 * An engine for {@link Storage} that uses an object instead of localStorage.
 * Used for unit testing.
 */
export class ObjectStorageEngine {
	/**
	 * No injections
	 */
	constructor() {
		this.clear();
	}

	/**
	 * Get the data with the given key
	 * @param {String} key
	 * @returns {*}
	 */
	getItem(key) {
		return this.data[key];
	}

	/**
	 * Set data by the given key
	 * @param {String} key
	 * @param {*} value
	 */
	setItem(key, value) {
		this.data[key] = value;
	}

	/**
	 * Delete data at the given key
	 * @param {String} key
	 */
	removeItem(key) {
		delete this.data[key];
	}

	/**
	 * Clear all data from storage
	 */
	clear() {
		/** @private */
		this.data = {};
	}
}
